'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function nodeIsText(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function nodeIsElement(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
function isElement(object) {
  return object instanceof Element;
}
function isShadyDOM() {
  return !!window.ShadyDOM;
}
function waitForImage(image) {
  return new Promise((resolve) => {
    if (!image) {
      return resolve();
    }
    if (image.complete && image.naturalHeight !== 0) {
      return resolve();
    }
    image.onload = () => {
      resolve();
    };
    image.onerror = () => {
      resolve();
    };
    image.onabort = () => {
      resolve();
    };
  });
}

exports.isElement = isElement;
exports.isShadyDOM = isShadyDOM;
exports.nodeIsElement = nodeIsElement;
exports.nodeIsText = nodeIsText;
exports.waitForImage = waitForImage;
